import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { SignupService } from '../../../services/sigup.service';
import { googleConfig } from '../../../../../../environments/environment';
import { LoginService } from '../../../services/login.service';
import { ToastrService } from 'ngx-toastr';
import { DecryptionService } from '../../../../shared/services/decryption.service';

@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [CommonModule,ReactiveFormsModule,RouterModule],
  templateUrl: './signup.component.html',
  styleUrl: './signup.component.scss'
})
export class SignupComponent implements OnInit {
  public isSignup : boolean = false;
  protected signupForm!: FormGroup;
  submitted: boolean = false;
  verifyEmail!: string;
  isLoading = false;
  showPassword: boolean = false;
  displayStyle2 = "none";
  confirmOtp!: FormGroup;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private signupData: SignupService,private signIn: LoginService,private toastr: ToastrService,private decryptionApi:DecryptionService
    ) {}

  ngOnInit(): void {
    this.confirmOtp = this.fb.group({
      otp: ['', Validators.required],
    })
    this.signupFormData();
  }
  
  signInWithGoogle(): void {
    googleConfig.googleClick()
  }
  get f() { 
    return this.signupForm.controls; 
  }

  clickSignupPage(){
    this.isSignup  = !this.isSignup;
  }

  onClick(){
    this.router.navigateByUrl("/login")
    }

    onClickHome(){
      this.router.navigateByUrl("/home")
    }

    signupFormData() {
      this.signupForm = this.fb.group({
        username: ['', Validators.required],
        firstname: ['', Validators.required],
        lastname: ['', Validators.required],
        email: new FormControl('', [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ]),
        password: ['', Validators.required],
        level: [1, Validators.required],
      });
      // this.varifyEmail = this.fb.group({
      //   sinupToken: ['', Validators.required]
      // })
    }

    

    signup(data: any) {
      this.submitted = true;
      this.verifyEmail = this.signupForm.controls['email'].value
      if (this.signupForm.valid) {
        this.isLoading = true;
        this.signupData.postSignup(data).subscribe({
          next: (response) => {
          if(response.success){
            this.displayStyle2 = "block";
          }
            this.toastr.success(response.message);
            this.isLoading = false;
            this.submitted = false;
          },
          error: (error) => {
            this.isLoading = false;
            this.toastr.error(error.error.message);
          }
        });
        

      }
  
    }

    OtpPopups() {
      const email = this.signupForm.value;
      email['email'] = email['email'];
      const otp = this.confirmOtp.value;
      let otpData = {
        query: email.email,
        otp: otp.otp
      }
  
      this.signIn.verifyOtpCode(otpData).subscribe({
        next: (response) => {
          const decrypt=  this.decryptionApi.decrypt(response.payload);
          const jsondecrpt=JSON.parse(decrypt);
          if (response.success = true) {
            this.otpClosePopUp();
            this.router.navigate(['home']);
            localStorage.setItem('loggedInUser', JSON.stringify(jsondecrpt));
          }
        }
      })
    }

    
  otpClosePopUp() {
    this.displayStyle2 = "none";
    this.confirmOtp.reset();
  }
  
 
}
